import { computed } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { useTokenStore } from '@/stores/token'
import * as bootstrap from 'bootstrap'
import setPageTitle from '@/helpers/setPageTitle'

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),

    routes: [
        {
            path: '/',
            name: 'main',
            component: () => import('@/views/ViewCars.vue'),
            meta: {
                onlyAuth: true,
                title: 'MENU_MAIN'
            }
        },

        {
            path: '/auth',
            component: () => import('@/views/ViewAuth.vue'),
            meta: {
                notAuth: true,
                breadcrumbs: []
            },
            children: [
                {
                    path: '',
                    name: 'auth',
                    component: () => import('@/components/auth/ASWAuth.vue'),
                    meta: {
                        onlyNotAuth: true,
                        title: 'MENU_AUTH'
                    }
                },
                {
                    path: '/registration',
                    name: 'registration',
                    component: () => import('@/components/auth/ASWRegistration.vue'),
                    meta: {
                        onlyNotAuth: true,
                        title: 'MENU_REGISTRATION'
                    }
                },
                {
                    path: '/forgot',
                    name: 'forgot',
                    component: () => import('@/components/auth/ASWForgot.vue'),
                    meta: {
                        onlyNotAuth: true,
                        title: 'MENU_FORGOT'
                    }
                }
            ]
        },

        {
            path: '/auth-srp',
            component: () => import('@/views/ViewAuth.vue'),
            meta: {
                notAuth: true,
                breadcrumbs: []
            },
            children: [
                {
                    path: '',
                    name: 'auth-srp',
                    component: () => import('@/components/auth/ASWAuthSrp.vue'),
                    meta: {
                        onlyNotAuth: true,
                        title: 'MENU_AUTH'
                    }
                }
            ]
        },

        {
            path: '/cars',
            name: 'cars',
            component: () => import('@/views/ViewCars.vue'),
            meta: {
                onlyAuth: true,
                title: 'CARS',
                breadcrumbs: {
                    parentName: 'main'
                }
            }
        },

        {
            path: '/cars/:carUuid',
            name: 'car',
            redirect: () => {
                return { name: 'car_info' }
            },
            props: true,
            component: () => import('@/views/ViewCar.vue'),
            meta: {
                onlyAuth: true,
                title: 'CAR',
                breadcrumbs: {
                    parentName: 'cars',
                    params: 'carUuid'
                }
            },
            children: [
                {
                    path: 'info',
                    name: 'car_info',
                    props: true,
                    component: () => import('@/components/car/ASWCarInfo.vue'),
                    meta: {
                        onlyAuth: true,
                        title: 'CARMENU_INFO',
                        breadcrumbs: {
                            parentName: 'car'
                        }
                    }
                },
                {
                    path: 'ecus',
                    name: 'car_ecus',
                    props: true,
                    component: () => import('@/components/car/ecus/ASWCarEcusList.vue'),
                    meta: {
                        onlyAuth: true,
                        title: 'CARMENU_ECUS',
                        breadcrumbs: {
                            parentName: 'car'
                        }
                    }
                },
                {
                    path: 'ecus/:ecuName',
                    name: 'car_ecu',
                    props: true,
                    component: () => import('@/components/car/ecus/ASWCarEcuWrapper.vue'),
                    meta: {
                        onlyAuth: true,
                        title: 'CARMENU_ECU',
                        breadcrumbs: {
                            parentName: 'car_ecus',
                            params: 'ecuName'
                        }
                    }
                },

                {
                    path: 'map',
                    name: 'car_map',
                    props: true,
                    component: () => import('@/components/car/ASWCarMap.vue'),
                    meta: {
                        onlyAuth: true,
                        title: 'CARMENU_MAP',
                        breadcrumbs: {
                            parentName: 'car'
                        }
                    }
                },
                {
                    path: 'areas',
                    name: 'car_areas',
                    props: true,
                    component: () => import('@/components/car/ASWCarAreas.vue'),
                    meta: {
                        onlyAuth: true,
                        title: 'CARMENU_AREAS',
                        breadcrumbs: {
                            parentName: 'car'
                        }
                    }
                },
                {
                    path: 'trips',
                    name: 'car_trips',
                    props: true,
                    component: () => import('@/components/car/ASWCarTrips.vue'),
                    meta: {
                        onlyAuth: true,
                        title: 'CARMENU_TRIPS',
                        breadcrumbs: {
                            parentName: 'car'
                        }
                    }
                },
                {
                    path: 'charging',
                    name: 'car_charging',
                    props: true,
                    component: () => import('@/components/car/ASWCarChargings.vue'),
                    meta: {
                        onlyAuth: true,
                        title: 'CARMENU_CHARGING',
                        breadcrumbs: {
                            parentName: 'car'
                        }
                    }
                },
                {
                    path: 'states',
                    name: 'car_states',
                    props: true,
                    component: () => import('@/components/car/states/ASWCarStates.vue'),
                    meta: {
                        onlyAuth: true,
                        title: 'CARMENU_STATE',
                        breadcrumbs: {
                            parentName: 'car'
                        }
                    }
                },
                {
                    path: 'car-users',
                    name: 'car_users',
                    props: true,
                    component: () => import('@/components/car/ASWCarUsers.vue'),
                    meta: {
                        onlyAuth: true,
                        title: 'CARMENU_USERS',
                        breadcrumbs: {
                            parentName: 'car'
                        }
                    }
                },
                {
                    path: 'events',
                    name: 'car_events',
                    props: true,
                    component: () => import('@/components/car/ASWCarEvents.vue'),
                    meta: {
                        onlyAuth: true,
                        title: 'CARMENU_EVENTS',
                        breadcrumbs: {
                            parentName: 'car'
                        }
                    }
                },
                {
                    path: 'history',
                    name: 'car_history',
                    props: true,
                    component: () => import('@/components/car/ASWCarHistory.vue'),
                    meta: {
                        onlyAuth: true,
                        title: 'CARMENU_HISTORY',
                        breadcrumbs: {
                            parentName: 'car'
                        }
                    }
                },
                {
                    path: 'rights',
                    name: 'car_rights',
                    props: true,
                    component: () => import('@/components/car/ASWCarRights.vue'),
                    meta: {
                        onlyAuth: true,
                        title: 'CARMENU_RIGHTS',
                        breadcrumbs: {
                            parentName: 'car'
                        }
                    }
                }
            ]
        },

        {
            path: '/firmwares',
            name: 'firmwares',
            component: () => import('@/views/ViewFirmwares.vue'),
            meta: {
                onlyAuth: true,
                title: 'MENU_FIRMWARES',
                breadcrumbs: {
                    parentName: 'main'
                }
            }
        },

        {
            path: '/firmwares/:fwName',
            name: 'firmware',
            component: () => import('@/views/ViewFirmware.vue'),
            props: true,
            meta: {
                onlyAuth: true,
                title: 'MENU_FIRMWARE',
                breadcrumbs: {
                    parentName: 'firmwares',
                    params: 'fwName'
                }
            }
        },

        {
            path: '/cars-groups',
            name: 'cars_groups',
            component: () => import('@/views/ViewCarsGroups.vue'),
            meta: {
                onlyAuth: true,
                title: 'CARS_GROUPS',
                breadcrumbs: {
                    parentName: 'main'
                }
            }
        },

        {
            path: '/cars-groups/:carsGroupUuid',
            name: 'cars_group',
            props: true,

            component: () => import('@/views/ViewCarsGroup.vue'),
            redirect: () => {
                return { name: 'group_info' }
            },
            meta: {
                onlyAuth: true,
                title: 'CARS_GROUP',
                breadcrumbs: {
                    parentName: 'cars_groups',
                    params: 'carsGroupUuid'
                }
            },
            children: [
                {
                    path: 'info',
                    name: 'group_info',
                    component: () => import('@/components/groupsCars/ASWCarsGroup.vue'),
                    props: true,
                    meta: {
                        onlyAuth: true,
                        title: 'CARS_GROUPS_INFO',
                        breadcrumbs: {
                            parentName: 'cars_group'
                        }
                    }
                },

                {
                    path: 'cars',
                    name: 'cars_group_cars',
                    component: () => import('@/components/ASWCarsGroupCars.vue'),
                    props: true,
                    meta: {
                        onlyAuth: true,
                        title: 'CARS_GROUPS_CARS',
                        breadcrumbs: {
                            parentName: 'cars_group'
                        }
                    }
                },

                {
                    path: 'users-groups',
                    name: 'cars_group_users_groups',
                    component: () => import('@/components/ASWCarsGroupUsersGroups.vue'),
                    props: true,
                    meta: {
                        onlyAuth: true,
                        title: 'CARS_GROUPS_USERS_GROUPS',
                        breadcrumbs: {
                            parentName: 'cars_group'
                        }
                    }
                }
            ]
        },

        {
            path: '/guide',
            name: 'guide',
            component: () => import('@/views/ViewGuide.vue'),
            meta: {
                onlyAuth: true,
                title: 'MENU_GUIDE',
                breadcrumbs: {
                    parentName: 'main'
                }
            }
        },

        {
            path: '/users',
            name: 'users',
            component: () => import('@/views/ViewUsers.vue'),
            meta: {
                onlyAuth: true,
                title: 'USERS',
                breadcrumbs: {
                    parentName: 'main'
                }
            }
        },

        {
            path: '/users/create',
            name: 'user_create',
            component: () => import('@/views/ViewUserCreate.vue'),
            meta: {
                onlyAuth: true,
                title: 'USER_CREATE',
                breadcrumbs: {
                    parentName: 'users'
                }
            }
        },

        {
            path: '/users/:userUuid',
            name: 'user',
            props: true,
            component: () => import('@/views/ViewUser.vue'),
            redirect: () => {
                return { name: 'user_info' }
            },
            meta: {
                onlyAuth: true,
                title: 'USER',
                breadcrumbs: {
                    parentName: 'users',
                    params: 'userUuid'
                }
            },
            children: [
                {
                    path: 'info',
                    name: 'user_info',
                    props: true,
                    component: () => import('@/components/user/ASWUserInfo.vue'),
                    meta: {
                        onlyAuth: true,
                        title: 'USER_INFO',
                        breadcrumbs: {
                            parentName: 'user'
                        }
                    }
                },
                {
                    path: 'cars',
                    name: 'user_cars',
                    props: true,
                    component: () => import('@/components/user/ASWUserCars.vue'),
                    meta: {
                        onlyAuth: true,
                        title: 'USER_CARS',
                        breadcrumbs: {
                            parentName: 'user'
                        }
                    }
                },
                {
                    path: 'logs',
                    name: 'user_logs',
                    props: true,
                    component: () => import('@/components/user/ASWUserLogs.vue'),
                    meta: {
                        onlyAuth: true,
                        title: 'USER_LOG',
                        breadcrumbs: {
                            parentName: 'user'
                        }
                    }
                },
                {
                    path: 'pwd',
                    name: 'user_pwd',
                    props: true,
                    component: () => import('@/components/user/ASWUserPassword.vue'),
                    meta: {
                        onlyAuth: true,
                        title: 'MENU_USER_CHANGE_PASSWORD',
                        breadcrumbs: {
                            parentName: 'user'
                        }
                    }
                }
            ]
        },

        {
            path: '/users-groups',
            name: 'users_groups',
            component: () => import('@/views/ViewUsersGroups.vue'),
            meta: {
                onlyAuth: true,
                title: 'USERS_GROUPS',
                breadcrumbs: {
                    parentName: 'main'
                }
            }
        },

        {
            path: '/users-groups/:usersGroupUuid',
            name: 'users_group',
            props: true,
            component: () => import('@/views/ViewUsersGroup.vue'),
            redirect: () => {
                return {
                    name: 'users_group_info'
                }
            },
            meta: {
                onlyAuth: true,
                title: 'MENU_USERS_GROUP',
                breadcrumbs: {
                    parentName: 'users_groups',
                    params: 'usersGroupUuid'
                }
            },

            children: [
                {
                    path: 'info',
                    name: 'users_group_info',
                    props: true,
                    component: () => import('@/components/groupsUsers/ASWUsersGroup.vue'),
                    meta: {
                        onlyAuth: true,
                        title: 'MENU_USERS_GROUP_INFO',
                        breadcrumbs: {
                            parentName: 'users_group'
                        }
                    }
                },
                {
                    path: 'users',
                    name: 'users_group_users',
                    props: true,
                    component: () => import('@/components/ASWUsersGroupUsers.vue'),
                    meta: {
                        onlyAuth: true,
                        title: 'MENU_USERS_GROUP_USERS',
                        breadcrumbs: {
                            parentName: 'users_group'
                        }
                    }
                },
                {
                    path: 'cars',
                    name: 'users_group_cars',
                    props: true,
                    component: () => import('@/components/ASWUsersGroupCars.vue'),
                    meta: {
                        onlyAuth: true,
                        title: 'MENU_USERS_GROUP_CARS',
                        breadcrumbs: {
                            parentName: 'users_group'
                        }
                    }
                },
                {
                    path: 'cars-groups',
                    name: 'users_group_cars_groups',
                    props: true,
                    component: () => import('@/components/ASWUsersGroupCarsGroups.vue'),
                    meta: {
                        onlyAuth: true,
                        title: 'MENU_USERS_GROUP_CARS_GROUPS',
                        breadcrumbs: {
                            parentName: 'users_group'
                        }
                    }
                }
            ]
        },
        {
            path: '/certificates',
            name: 'certificates',
            props: true,
            component: () => import('@/views/ViewCertificates.vue'),
            meta: {
                onlyAuth: true,
                title: 'CERTIFICATES',
                breadcrumbs: { parentName: 'main' }
            }
        },
        {
            path: '/certificates/:imei',
            name: 'certificate',
            props: true,
            component: () => import('@/views/ViewCertificate.vue'),
            meta: {
                onlyAuth: true,
                title: 'CERTIFICATE',
                breadcrumbs: { parentName: 'certificates', params: 'imei' }
            }
        },
        {
            path: '/areas',
            name: 'areas',
            props: true,
            component: () => import('@/views/ViewAreas.vue'),
            meta: {
                onlyAuth: true,
                title: 'MENU_AREAS',
                breadcrumbs: { parentName: 'main' }
            }
        },
        {
            path: '/areas/:uuid',
            name: 'area',
            props: true,
            component: () => import('@/views/ViewAreasEdit.vue'),
            meta: {
                onlyAuth: true,
                title: 'AREA',
                breadcrumbs: { parentName: 'areas', params: 'uuid' }
            }
        },
        {
            path: '/areas/create',
            name: 'areas_create',
            component: () => import('@/views/ViewAreasCreate.vue'),
            meta: {
                onlyAuth: true,
                title: 'AREAS_CREATE',
                breadcrumbs: { parentName: 'areas' }
            }
        },
        {
            path: '/test',
            name: 'test',
            props: true,
            component: () => import('@/views/ViewTest.vue'),
            meta: {
                onlyAuth: true,
                title: 'PAGE_TEST',
                breadcrumbs: { parentName: 'main' }
            }
        },
        {
            path: '/test-ws',
            name: 'test_ws',
            props: true,
            component: () => import('@/views/ViewTestWs.vue'),
            meta: {
                onlyAuth: true,
                title: 'PAGE_TEST',
                breadcrumbs: { parentName: 'main' }
            }
        },

        {
            path: '/:catchAll(.*)',
            name: '404',
            component: () => import('@/views/ViewError404.vue'),
            meta: {
                onlyAuth: true
            }
        }
    ]
})

router.beforeEach((to, from, next) => {
    const tokenStore = useTokenStore()
    const access = computed(() => tokenStore.access)

    if (to.meta.title) {
        setPageTitle(to.meta.title)
    }

    const naviMenu = document.getElementById('navbarSupportedContent')

    if (naviMenu && naviMenu.classList.contains('show')) {
        new bootstrap.Collapse(naviMenu, { hide: true })
    }

    // @TODO: Скрол к началу документа; убрать событие роута с табов

    // if (document.documentElement.scrollTop) {

    //     document.documentElement.scrollTop = 0

    // } else if (document.body.scrollTop) {

    //     document.body.scrollTop = 0
    // }

    if (to.meta.onlyNotAuth && access.value) {
        next('/')
        return
    }

    if (to.matched.some(record => record.meta.onlyAuth)) {
        if (access.value) {
            next()
            return
        }
        next('/auth')
    } else {
        next()
    }
})

export default router
